import Page from 'src/player/sdk/reference/index';

export default Page;
